module.exports = __webpack_public_path__ + "img/1542792630.5579c7cb.jpg";